// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rg-table input[type=\"radio\"][data-v-2f03072c], .rg-table input[type=\"checkbox\"][data-v-2f03072c] {\n    height: 16px !important;\n}\n\n/*https://docs.realgrid.com/guides/renderer/custom-renderer-img-buttons*/\n\n/* a.no-uline:hover{\n  text-decoration:underline !important;\n} */\nul.grid[data-v-2f03072c]{\n position:absolute;\n}\nspan.float[data-v-2f03072c] {\n  float:right;\n}\n.tbl_search td[data-v-2f03072c] {\n  padding: 4px 10px 0px 10px !important;\n}\n ", ""]);
// Exports
module.exports = exports;
